// const Configurl = {
//     "DefaultOrganizationLogo": "https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/ken42(png).png",
//     "OrganizationName": "Alumni",
//     "OrganizationbaseURL": "https://dev-alumniportal.ken42.com/",
//     "apiUrl": "dev-alumniportal.ken42.com",
//     "BackendbaseURL":"https://alumni-node-dev-api.ken42.com/"
// };


export const Configurl = {
    DefaultOrganizationLogo: "https://iimustorageprod.blob.core.windows.net/iimu-data/KISLogo.png",
    OrganizationName: "KIS",
    apiBaseUrl: "https://ken-api-dev-2.ken42.com/kis-node-dev"
};
export default Configurl;